module.exports = __webpack_public_path__ + "static/img/location.d8721a51.png";